module.exports = __webpack_public_path__ + "img/img-5.fde1251d.png";